import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import colors from 'vuetify/es5/util/colors';
import '@mdi/font/css/materialdesignicons.css'
import VuetifyDialog from 'vuetify-dialog'
import 'vuetify-dialog/dist/vuetify-dialog.css'

Vue.use(Vuetify);


Vue.use(VuetifyDialog, {
  context: {
    Vuetify
  }
})

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#7E22CE",
        secondary: "#06B6D4",
        accent: colors.blue.base,
        error: colors.red.base,
        warning: colors.orange.base,
        info: colors.lightBlue.base,
        success: colors.green.base,
      },
      dark: {
        primary: colors.deepPurple.base
      }
    }
  }
});
